<template>
  <v-dialog v-model="ShowHide" :overlay="false" max-width="1000px" persistent
  :fullscreen="$vuetify.breakpoint.smAndDown" transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar color="blue darken-3" dark flat>
        <v-toolbar-title>
          <span class="font-awesome display-1 ml-5">{{ canEdit ? title : 'Información del Empleado' }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="$emit('close')" icon>
          <v-icon size="30">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="6" sm="4" md="4" lg="3">
            <v-text-field v-model="clave" :readonly="!canEdit" autocomplete="off"
              name="clave" maxlength="15" prepend-inner-icon="mdi-book-variant" color="indigo accent-4"
              label="Clave Empleado" @input="$v.clave.$touch()" @blur="ValidateClave()" :error-messages="claveErrors">
            </v-text-field>
          </v-col>
          <v-col cols="6" sm="4" md="4" lg="3">
            <v-text-field
              v-model="nombre"
              :readonly="!canEdit"
              @input="$v.nombre.$touch()"
              @blur="$v.nombre.$touch()"
              :error-messages="nombreErrors"
              name="nombre"
              prepend-inner-icon="mdi-shield-account"
              color="indigo accent-4"
              label="Nombre empleado"
              maxlength="100"
              autocomplete="off"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="4" md="4" lg="3">
            <v-text-field
              name="telefono"
              :readonly="!canEdit"
              ref="inputtelefono"
              label="Teléfono"
              v-model="telefono"
              @input="$v.telefono.$touch()"
              @blur="$v.telefono.$touch()"
              :error-messages="telefonoErrors"
              @keypress="eventKeypress"
              maxlength="14"
              prepend-inner-icon="mdi-cellphone"
              color="indigo accent-4"
              autocomplete="off"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="4" md="4" lg="3">
            <v-text-field
              name="email"
              ref="emailinput"
              label="Email"
              v-model="email"
              :readonly="!canEdit"
              @input="$v.email.$touch()"
              @blur="$v.email.$touch()"
              :error-messages="emailErrors"
              prepend-inner-icon="mdi-email"
              color="indigo accent-4"
              autocomplete="off"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="4" md="4" lg="3">
            <v-autocomplete
              :items="WorkStation"
              :readonly="!canEdit"
              label="Puesto"
              item-text="name"
              return-object
              item-value="id"
              v-model="puesto"
              @input="$v.puesto.$touch()"
              @blur="$v.puesto.$touch()"
              :error-messages="puestoErrors"
              autocomplete="off"
            >
              <template v-slot:prepend v-if="canEdit">
                <v-tooltip bottom max-width="300" color="indigo darken-3">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      @click="showAbc"
                      v-on="on"
                      x-small
                      color="indigo darken-4"
                      fab
                    >
                      <v-icon> mdi-pencil </v-icon>
                    </v-btn>
                  </template>
                  <span>Agregar nuevo puesto</span>
                </v-tooltip>
              </template>

              <template v-slot:append v-if="canEdit">
                <v-tooltip bottom max-width="300" color="indigo darken-3">
                  <template v-slot:activator="{ on }">
                    <v-icon color="indigo accent-4" v-on="on"
                      >mdi-help-circle-outline</v-icon
                    >
                  </template>
                  Listado de puestos dados de alta pude modificarlo o dar de
                  alta nuevos
                </v-tooltip>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="6" sm="4" md="4" lg="3">
            <v-text-field
              v-model="nivel"
              readonly
              label="Nivel empleado"
              prepend-inner-icon="mdi-lock-outline"
              autocomplete="off"
            >
              <template v-slot:append>
                <v-tooltip bottom max-width="200" color="indigo darken-3">
                  <template v-slot:activator="{ on }">
                    <v-icon color="indigo accent-4" v-on="on">mdi-help-circle-outline</v-icon>
                  </template>
                  Nivel otorgado en el puesto no se puede modificar
                </v-tooltip>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="6" sm="4" md="4" lg="3">
            <v-menu
              ref="menu"
              v-model="menu"
              :disabled="!canEdit"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="checkInTime"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
              autocomplete="off"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="checkInTime"
                  label="Horario de Entrada"
                  prepend-inner-icon="mdi-clock"
                  readonly
                  @input="$v.checkInTime.$touch()"
                  @blur="$v.checkInTime.$touch()"
                  :error-messages="HorarioEntradaError"
                  v-on="on"
                ></v-text-field>
              </template>

              <v-time-picker
                v-if="menu"
                v-model="checkInTime"
                full-width
                @click:minute="$refs.menu.save(checkInTime)"
              ></v-time-picker>
            </v-menu>
          </v-col>
          <v-col cols="6" sm="4" md="4" lg="3">
            <v-menu
              ref="salida"
              v-model="menu2"
              :disabled="!canEdit"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="checkOutTime"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
              autocomplete="off"
            >
              <template v-slot:activator="{ on }">
                <v-text-field v-model="checkOutTime" label="Horario de Salida"
                  @input="$v.checkOutTime.$touch()" @blur="$v.checkOutTime.$touch()"
                  :error-messages="HorarioSalidaError" prepend-inner-icon="mdi-clock-alert"
                  readonly v-on="on">
                </v-text-field>
              </template>

              <v-time-picker
                v-if="menu2"
                v-model="checkOutTime"
                full-width
                @click:minute="$refs.salida.save(checkOutTime)"
              ></v-time-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="4" md="4" lg="3">
            <v-text-field
              v-model="pass"
              @input="$v.pass.$touch()"
              @blur="$v.pass.$touch()"
              :error-messages="passErrors"
              name="password"
              prepend-inner-icon="mdi-link-lock"
              color="indigo accent-4"
              label="Contraseña "
              counter
              maxlength="10"
              :type="show ? 'text' : 'password'"
              @click:append="show = !show"
              hint="SOLO NUMEROS"
              v-mask="mask"
              :append-icon="show ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
              @keypress="EventKey"
              v-if="canEdit"
              autocomplete="off"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="4" md="4" lg="3">
            <v-text-field
              label="Porcentaje de descuento"
              v-model="descuentoAut"
              id="id"
              required
              :readonly="!canEdit"
              v-mask="percent"
              @input="$v.descuentoAut.$touch()"
              @blur="$v.descuentoAut.$touch()"
              :error-messages="DdiscountErr"
              hint="Esto es en porcentaje % "
              autocomplete="off"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="6">
            <v-list subheader>
              <v-list-group value="true">
                <template v-slot:activator>
                  <v-list-item-title>
                    <b>Selecciona las Sucursales</b>
                  </v-list-item-title>
                </template>
                <v-subheader
                  >{{ model.length }} sucursal{{
                    model.length > 1 || model.length == 0 ? `es` : ""
                  }}
                  seleccionada{{
                    model.length || model.length == 0 > 1 ? "s" : ""
                  }}
                </v-subheader>
                <div class="red--text">
                  {{ SucursalesError[0] }}
                </div>
                <v-list>
                  <v-list-item-group v-model="model" multiple>
                    <template v-for="(item, i) in Sucursales">
                      <v-list-item
                        :key="`item-${i}`"
                        :value="item.id"
                        active-class="indigo--text text--accent-4"
                      >
                        <template v-slot:default="{ active, toggle }">
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ `SUC.  ${item.name}` }}
                            </v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-checkbox :input-value="active" :disabled="!canEdit" color="primary">
                            </v-checkbox>
                          </v-list-item-action>
                        </template>
                      </v-list-item>
                    </template>
                  </v-list-item-group>
                </v-list>
              </v-list-group>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          color="red darken-4"
          class="font-weight-bold"
          @click="$emit('close')"
          >Cerrar</v-btn
        >
        <v-btn
          v-if="canEdit"
          :disabled="setDisabled"
          color="blue darken-1"
          class="font-weight-bold"
          @click="Guardar()"
          >Guardar</v-btn
        >
      </v-card-actions>
    </v-card>
    <loading
      :active.sync="loading"
      background-color="#C5CAE9"
      color="#1A237E"
      :is-full-page="true"
    ></loading>
    <modal-puestos
      :dialog="dialog2"
      @Cerrar="Cerrar"
      @ShowBar="ShowBar"
      :WorkStation="WorkStation"
      @LoadworkStation="LoadworkStation"
    />
    <v-snackbar v-model="showSnakc" :timeout="2500" :color="color"
      >{{ text }}
    </v-snackbar>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { validationMixin } from "vuelidate";
import { required, maxLength, email, maxValue, requiredUnless } from "vuelidate/lib/validators";
import "vue-loading-overlay/dist/vue-loading.css";
import { mask } from "vue-the-mask";
import Swal from "sweetalert2";
import moment from "moment";
export default {
  directives: {
    mask,
  },
  mixins: [validationMixin],
  validations: {
    clave: { required },
    telefono: { required },
    nombre: { required },
    email: { required, email },
    puesto: { required },
    pass: { required:  requiredUnless(function() {
      return this.edited ? true : false;
    })},
    checkInTime: { required },
    checkOutTime: { required },
    descuentoAut: { required, maxValue: maxValue(100) },
  },
  components: {
    ModalPuestos: () => import("../../base/AbcPuestos"),
    Loading: () => import("vue-loading-overlay"),
  },
  data() {
    return {
      WorkStation: [],
      mask: "##########",
      percent: "###",
      dialog2: false,
      showSnakc: false,
      text: null,
      color: "",
      level: null,
      workStationId: null,
      position: null,
      porcentajes_: [],
      show: false,
      checkInTime: null,
      checkOutTime: null,
      niveles: [
        {
          id: 0,
          name: "Operador",
        },
        {
          id: 1,
          name: "Gerente",
        },
        {
          id: 2,
          name: "Administrador",
        },
      ],
      menu: false,
      menu2: false,
      clave: null,
      nombre: null,
      puesto: null,
      nivel: "",
      Horario: [
        {
          entrada: null,
          salida: null,
        },
      ],
      pass: null,
      descuentoAut: null,
      telefono: null,
      email: null,
      valid: true,
      lazy: false,
      model: [],
    };
  },
  watch: {
    showHide(val) {
      this.$v.$reset();
      this.clave = "";
      this.nombre = "";
      this.puesto = "";
      this.nivel = "";
      this.telefono = "";
      this.email = "";
      this.password = "";
      this.pass = null;
      this.checkInTime = "";
      this.checkOutTime = "";
      this.descuentoAut = "";
      this.model = [];
    },
    puesto(val) {
      //console.log(val.level);
      if (val.level != undefined) {
        this.workStationId = val.id;
        this.position = val.name;
        this.nivel = this.myLevel(val.level);
      } else {
        //console.log(this.editedItem[0].workStation.id);
        //this.workStationId = this.editedItem[0]
      }
      //  console.log(this.nivel);

      //
    },
  },
  props: {
    dialog: {
      default: false,
    },
    canEdit:{
      type:Boolean,
      default: false,
    },
    edited: {
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    editedItem: {
      type: Array,
      default: () => ({
        name: undefined,
      }),
    },
  },
  methods: {
    ValidateClave() {
      if(!this.edited){
        this.$v.clave.$touch();
        if (!this.$v.clave.$error) {
          const val = this.$v.clave.$model;

          const g = _.find(this.getEmployes, { code: val });
          if (g) {
            this.clave = "";
            this.showSnakc = true;
            this.text = `La clave de empelado ${val} ya ha sido registrado`;
            this.color = "error";
            this.$v.clave.$touch();
          }
        }
      }
    },
    LoadworkStation() {
      axios.get("/api/Catalogs/WorkStation", {
        headers: {
            bussinessId: localStorage.getItem("_bussinessAccountId"),
        },
      }).then((result) => {
          this.WorkStation = result.data;
      }).catch((err) => {
          Swal.fire("Oooops", "Algo salio mal", "error");
      });
    },
    myLevel(val) {
      switch (val) {
        case 2:
          return "Administrador";
        case 1:
          return "Gerente";
        case 0:
          return "Operador";
      }
    },
    ShowBar(val) {
      this.$emit("ShowBar", val);
    },
    Cerrar() {
      this.dialog2 = false;
    },
    showAbc() {
      this.dialog2 = true;
    },

    setPorcentaje() {
      for (let index = 1; index <= 100; index++) {
        this.porcentajes_.push(index + "%");
      }
    },
    EventKey: function ($e) {},
    initialized() {
      if (this.$store.state.BranchOffice.length == 0) {
        axios.get("/api/BranchOffice/GetByAccount/" + this.$store.state._bussinessAccountId)
        .then((result) => {
          return result.data;
        })
        .then((data) => {
          this.$store.commit("SET_BRANCH", data);
        })
        .catch((err) => {
          console.log(err);
        });
      }
    },
    Guardar() {
      this.$v.$touch();

      if (this.$v.clave.required) {
        let val = this.descuentoAut;
        let val_ = null;
        let maximumDiscount = null;
        if (val != null) {
          val_ = parseInt(val.split("%")[0]);
          maximumDiscount = parseFloat(val_ / 100);
        }

        this.$emit("Guardar", {
          code: this.clave,
          name: this.nombre,
          position: this.position,
          workStationId: this.workStationId,
          checkInTime: `${this.checkInTime}:00`,
          checkOutTime: `${this.checkOutTime}:00`,
          password: this.pass,
          maximumDiscount: maximumDiscount,
          telephone: this.telefono,
          email: this.email,
          branchOffices: this.model,
        });
      } else {
        this.showSnakc = true;
        this.text = "Los campos Marcando en Rojo son obligatorios";
        this.color = "error";
      }
    },
    eventKeypress: function ($e) {
      let target = $e.target,
        position = target.selectionEnd;
      target.value = target.value
        .replace(/[^0-9]/g, "")
        .replace(/(\d{3})(\d{3})(\d{4})/g, "($1) $2 $3");
    },
    SetBranches() {
      if (this.edited) {
        // alert('Editando')
      }
      /* alert("Holaaaaa desde Aqui");
       */
    },
  },
  computed: {
    setDisabled() {
      var disabled = true;
      if(this.edited){
        if (
          this.$v.clave.required &&
          this.$v.telefono.required &&
          this.$v.nombre.required &&
          this.$v.email.required &&
          this.$v.puesto.required &&
          this.$v.descuentoAut.required &&
          this.$v.descuentoAut.maxValue &&
          this.model.length > 0
        ) {
          disabled = false;
        }
      }else{
        if (
          this.$v.clave.required &&
          this.$v.telefono.required &&
          this.$v.nombre.required &&
          this.$v.email.required &&
          this.$v.puesto.required &&
          this.$v.pass.required &&
          this.$v.descuentoAut.required &&
          this.$v.descuentoAut.maxValue &&
          this.model.length > 0
        ) {
          disabled = false;
        }
      }
      return disabled;
    },
    DdiscountErr() {
      const errors = [];
      if (!this.$v.descuentoAut.$dirty) return errors;
      !this.$v.descuentoAut.maxValue &&
        errors.push("El valor maximo es de 100 ");
      !this.$v.descuentoAut.required && errors.push(this.$t("errors.required"));
      return errors;
    },
    puestoErrors() {
      const errors = [];
      if (!this.$v.puesto.$dirty) return errors;
      !this.$v.puesto.required && errors.push(this.$t("errors.required"));
      return errors;
    },
    passErrors() {
      const errors = [];
      if (!this.$v.pass.$dirty) return errors;
      !this.$v.pass.required && errors.push(this.$t("errors.required"));
      return errors;
    },
    telefonoErrors() {
      const errors = [];
      if (!this.$v.telefono.$dirty) return errors;
      !this.$v.telefono.required && errors.push(this.$t("errors.required"));
      return errors;
    },
    nombreErrors() {
      const errors = [];
      if (!this.$v.nombre.$dirty) return errors;
      !this.$v.nombre.required && errors.push(this.$t("errors.required"));
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.required && errors.push(this.$t("errors.required"));
      !this.$v.email.email && errors.push(this.$t("errors.email"));
      return errors;
    },
    claveErrors() {
      const errors = [];
      if (!this.$v.clave.$dirty) return errors;
      !this.$v.clave.required && errors.push(this.$t("errors.required"));
      return errors;
    },
    HorarioEntradaError() {
      const errors = [];
      if (!this.$v.checkInTime.$dirty) return errors;
      !this.$v.checkInTime.required && errors.push(this.$t("errors.required"));
      return errors;
    },
    HorarioSalidaError() {
      const errors = [];
      if (!this.$v.checkOutTime.$dirty) return errors;
      !this.$v.checkOutTime.required && errors.push(this.$t("errors.required"));
      return errors;
    },
    SucursalesError() {
      const errors = [];
      if(this.model.length === 0) errors.push("Debes seleccionar al menos 1 sucursal");
      return errors;
    },
    Sucursales() {
      return this.$store.state.BranchOffice;
    },
    title() {
      let titulo = "";
      if (this.edited) {
        titulo = "Editando Empleado";
      } else {
        titulo = "Nuevo empleado";
        this.model = [];
      }

      return titulo;
    },
    getEmployes: {
      get() {
        return this.$store.state.Empleados;
      },
      set() {},
    },
    /* Para limpiar el modal */
    showHide: {
      get() {
        return this.$store.state.showModal;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    /* Para el Modal */
    ShowHide: {
      get: function () {
        if (this.dialog) {
          this.initialized();
          this.setPorcentaje();
          this.LoadworkStation();
          this.SetBranches();
          if (this.edited) {
            this.clave = this.editedItem[0].code;
            this.nombre = this.editedItem[0].name;
            this.email = this.editedItem[0].email;
            this.puesto = this.editedItem[0].workStation;
            this.workStationId = this.editedItem[0].workStation.id;
            this.position = this.editedItem[0].workStation.name;
            this.nivel = this.editedItem[0].workStation.name;
            this.telefono = this.editedItem[0].telephone;
            this.checkInTime = moment(
              this.editedItem[0].checkInTime,
              "hh:mm:ss"
            ).format("HH:mm");
            this.checkOutTime = moment(
              this.editedItem[0].checkOutTime,
              "hh:mm:ss"
            ).format("HH:mm");

            this.descuentoAut = `${parseInt(
              this.editedItem[0].maximumDiscount * 100
            )} %`;
            const branches = this.editedItem[0].branchOffices;
            let b_ = [];
            _.map(branches, (e) => {
              b_.push(e.id);
            });
            this.model = b_;
          }
        }
        return this.dialog;
      },
      set: function (val) {
        if (!val) {
          this.$emit("close");
        }
      },
    },
  },
};
</script>
